'use strict';
// Tabbed card grids: clicking a pill shows its panel and hides the others.
// Keyboard nav follows the WAI-ARIA tabs pattern (Left/Right/Home/End).
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.block.accordion-cards [data-accordion-cards]').forEach((tablist) => {
        const root = tablist.closest('.block.accordion-cards');
        if (!root) {
            return;
        }
        const tabs = Array.from(tablist.querySelectorAll('[data-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-panel]'));
        if (tabs.length === 0) {
            return;
        }
        const activate = (index, setFocus = false) => {
            tabs.forEach((tab, i) => {
                const selected = i === index;
                tab.classList.toggle('is-active', selected);
                tab.setAttribute('aria-selected', selected ? 'true' : 'false');
                tab.setAttribute('tabindex', selected ? '0' : '-1');
                if (selected && setFocus) {
                    tab.focus();
                }
            });
            panels.forEach((panel, i) => {
                if (i === index) {
                    panel.removeAttribute('hidden');
                }
                else {
                    panel.setAttribute('hidden', '');
                }
            });
        };
        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => activate(i));
            tab.addEventListener('keydown', (event) => {
                let next = -1;
                switch (event.key) {
                    case 'ArrowRight':
                        next = (i + 1) % tabs.length;
                        break;
                    case 'ArrowLeft':
                        next = (i - 1 + tabs.length) % tabs.length;
                        break;
                    case 'Home':
                        next = 0;
                        break;
                    case 'End':
                        next = tabs.length - 1;
                        break;
                    default:
                        return;
                }
                event.preventDefault();
                activate(next, true);
            });
        });
    });
});
